import { cx } from '@libs/classnames';
import { InfiniteScroll } from '@ui/components/InfiniteScroll';
import { Loader } from '@ui/components/Loader';
import { Placeholder } from '@ui/components/Placeholder/Placeholder';
import { LaurelWreathLeft } from '@ui/icons/LaurelWreathLeft/LaurelWreathLeft';
import { LaurelWreathRight } from '@ui/icons/LaurelWreathRight/LaurelWreathRight';

import { Winner } from '@features/shared/api/typings';

import styles from './WinnersList.module.css';

type Props = {
  className?: string;
  winners?: Winner[];
  maxVisible?: number;
  onLoadMore: () => void;
  hasMore: boolean;
  isModal?: boolean;
  isLoading?: boolean;
};
export function WinnersList({
  className,
  winners,
  maxVisible,
  onLoadMore,
  hasMore,
  isModal,
  isLoading,
}: Props) {
  if (!winners) return <Loader />;

  let items: { key: string; title: string; subTitle: string }[] = [];
  winners.forEach((winner) =>
    winner.winnerTitles.forEach((title, i) => {
      items.push({
        key: winner.tournamentId + title + i,
        title,
        subTitle: winner.tournamentTitle,
      });
    }),
  );

  if (!winners.length) {
    if (isLoading) {
      return <Loader centered />;
    }

    return <Placeholder>Победителей пока нет</Placeholder>;
  }

  if (maxVisible) {
    items = items.slice(0, maxVisible);
  }

  return (
    <InfiniteScroll
      scrollableClassName={className}
      fetchMore={onLoadMore}
      hasMore={hasMore}
      itemsLength={winners.length}
    >
      <div className={cx(styles.winnersList, { [styles.isModal]: isModal })}>
        {items.map((item) => (
          <WinnersListItem key={item.key} title={item.title} subTitle={item.subTitle} />
        ))}
      </div>
    </InfiniteScroll>
  );
}

type WinnersListItemProps = {
  title: string;
  subTitle: string;
};
export function WinnersListItem({ title, subTitle }: WinnersListItemProps) {
  return (
    <div className={styles.winner}>
      <div className={styles.laurelWreath}>
        <LaurelWreathLeft />
      </div>
      <div className={styles.name}>
        <div className={styles.title}>{title}</div>
        <div className={styles.subTitle}>{subTitle}</div>
      </div>
      <div className={styles.laurelWreath}>
        <LaurelWreathRight className={styles.laurelWreath} />
      </div>
    </div>
  );
}
